// Support Center main application file
import '@hotwired/turbo-rails'
import { Application } from '@hotwired/stimulus'

// Import controllers
import SearchController from './controllers/search_controller'
import ArticleFeedbackController from './controllers/article_feedback_controller'
import MobileMenuController from './controllers/mobile_menu_controller'
import CopyLinkController from './controllers/copy_link_controller'
import FlashController from '../controllers/flash_controller'
import MarkdownEditorController from '../controllers/markdown_editor_controller'
import UrlCleanerController from '../controllers/url_cleaner_controller'

// Start Stimulus application
const application = Application.start()
application.debug = false
window.SupportCenterStimulus = application

// Register controllers
application.register('search', SearchController)
application.register('article-feedback', ArticleFeedbackController)
application.register('mobile-menu', MobileMenuController)
application.register('copy-link', CopyLinkController)
application.register('flash', FlashController)
application.register('markdown-editor', MarkdownEditorController)
application.register('url-cleaner', UrlCleanerController)

console.log('Support Center application loaded')

export { application }